function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import autoloadMixin from "../mixins/list/autoload.js";
import ThumbnailTemplate from "../../templates/thumbnail";
import FeaturedTemplate from "../../templates/featured";
import CommentTemplate from "../../templates/comment";
import actionCableMixin from "../mixins/ws/actionCable.js";
export default {
  components: {
    draggable: draggable,
    "template-thumbnail": ThumbnailTemplate,
    "template-featured": FeaturedTemplate,
    "template-commentOutgoing": CommentTemplate,
    "template-commentIncoming": CommentTemplate
  },
  mixins: [autoloadMixin, actionCableMixin],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      sections: []
    };
  },
  computed: {
    twoLine: function twoLine() {
      var _iterator = _createForOfIteratorHelper(this.sections),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var section = _step.value;
          var rows = section.rows || [];

          var _iterator2 = _createForOfIteratorHelper(rows),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var row = _step2.value;

              if (row.subtitle) {
                return true;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    },
    threeLine: function threeLine() {
      var _iterator3 = _createForOfIteratorHelper(this.sections),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var section = _step3.value;
          var rows = section.rows || [];

          var _iterator4 = _createForOfIteratorHelper(rows),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var row = _step4.value;

              if (row.subsubtitle) {
                return true;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return false;
    }
  },
  methods: {
    $ready: function $ready() {
      this.sections = this.spec.sections || [];
      this.autoloadAll(this.spec.nextPage);
      this.enableInfiniteScrollIfApplicable();
      this.$wsSubscribeEvents(this.spec.phoenixSocket);
      this.$wsInitActionCable(this.spec.actionCable);

      var _iterator5 = _createForOfIteratorHelper(this.sections),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var section = _step5.value;
          section.rows = section.rows || [];
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    },
    rowSpec: function rowSpec(row) {
      if (this.spec.fieldPrefix) {
        var prefix = "".concat(this.spec.fieldPrefix, "[").concat(row.recordId, "]");
        return Object.assign({}, row, {
          fieldCheckName: "".concat(prefix, "[checked]"),
          fieldTitleName: this.spec.fieldTitleName ? "".concat(prefix, "[").concat(this.spec.fieldTitleName, "]") : null,
          fieldCheckValueIf: this.spec.fieldCheckValueIf
        });
      }

      return row;
    },
    action_loadNext: function action_loadNext(spec) {
      console.log("TODO: load new comments and append to this list", spec); // TODO
      // - Load next rows/items from the Rails server
      //   - You can pass some parameters (e.g. currentItemId) for pagination
      //   - For example, if currentItemId is 56, the server will know that it needs to
      //     return items that are newer than 56
      //   - You may use other ways for pagination as well
      // - Append the rows to this list
    },
    action_append: function action_append(spec) {
      var _this = this;

      var _iterator6 = _createForOfIteratorHelper(spec.sections.entries()),
          _step6;

      try {
        var _loop = function _loop() {
          var _ref = _step6.value;
          _ref2 = _slicedToArray(_ref, 2);
          var index = _ref2[0];
          var appendedSection = _ref2[1];
          var section = _this.sections[index] || {};

          if (!section.rows) {
            _this.$set(section, "rows", []);
          }

          Utils.type.ifArray(appendedSection.rows, function (rows) {
            var _iterator7 = _createForOfIteratorHelper(rows),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var row = _step7.value;
                section.rows.push(row);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          });
        };

        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref2;

          _loop();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    },
    action_update: function action_update(spec) {
      var updatedRows = {};
      Utils.type.ifArray(spec.rows, function (rows) {
        var _iterator8 = _createForOfIteratorHelper(rows),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var row = _step8.value;
            updatedRows[row.id] = row;
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      });

      var _iterator9 = _createForOfIteratorHelper(this.sections),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var section = _step9.value;
          section.rows = section.rows.map(function (row) {
            var updatedRow = updatedRows[row.id];

            if (updatedRow) {
              return updatedRow;
            } else {
              return row;
            }
          });
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    },
    action_delete: function action_delete(spec) {
      var deletedRows = {};
      Utils.type.ifArray(spec.rows, function (rows) {
        var _iterator10 = _createForOfIteratorHelper(rows),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var row = _step10.value;
            deletedRows[row.id] = row;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      });

      var _iterator11 = _createForOfIteratorHelper(this.sections),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var section = _step11.value;
          section.rows = section.rows.filter(function (row) {
            // return !rows.includes(row.id);
            return !deletedRows[row.id];
          });
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    },
    $tearDown: function $tearDown() {
      this.cancelAutoloadRequest();
    },
    template: function template(row) {
      var name = "template-".concat(row.template.replace("/", "-"));
      var strict = true;

      if (strict) {
        return name;
      } else {
        if (this.$options.components[name]) {
          return name;
        }

        console.warn("Invalid template: ".concat(row.template));
        return null;
      }
    },
    serializedSpec: function serializedSpec(row) {
      return JSON.stringify(row);
    },
    onDragEnd: function onDragEnd(event) {
      var _ref3;

      var targetSectionedRowIndex = event.newIndex;

      if (event.from == event.to && event.oldIndex == targetSectionedRowIndex) {
        console.log("Reordering canceled");
        return;
      }

      var targetSectionIndex = this.getSectionIndex(event.to);
      var targetSection = this.getSection(targetSectionIndex); // The dragged row is now on the new index

      var draggedRow = targetSection.rows[targetSectionedRowIndex];
      var targetAbsoluteIndex = this.previousSectionsRowCount(event.to) + targetSectionedRowIndex;
      var mergedSpec = Object.assign(draggedRow.onReorder, _defineProperty({}, draggedRow.paramNameForFormData || "formData", (_ref3 = {}, _defineProperty(_ref3, draggedRow.paramNameForNewIndex, targetAbsoluteIndex), _defineProperty(_ref3, draggedRow.paramNameForNewAbsoluteIndex || "newAbsoluteIndex", targetAbsoluteIndex), _defineProperty(_ref3, draggedRow.paramNameForNewSectionIndex || "newSectionIndex", targetSectionIndex), _defineProperty(_ref3, draggedRow.paramNameForNewSectionedRowIndex || "newSectionedRowIndex", targetSectionedRowIndex), _ref3)));
      GLib.action.execute(mergedSpec, this);
    },
    getSectionIndex: function getSectionIndex(element) {
      return element.dataset.index;
    },
    getSection: function getSection(sectionIndex) {
      return this.sections[sectionIndex];
    },
    previousSectionsRowCount: function previousSectionsRowCount(element) {
      var sectionIndex = this.getSectionIndex(element);
      var count = 0;

      for (var i = 0; i < sectionIndex; i++) {
        count += this.getSection(i).rows.length;
      }

      return count;
    }
  }
};